<template>
  <div class="homepage">
    Not Found
  </div>
</template>
<script>
export default {
  methods: {

  }
}
</script>